import { memo } from 'react';
import { css } from '@emotion/react';
import { EdgeLabelRenderer, EdgeProps, getBezierPath } from 'reactflow';
import { typography } from '@uniquegood/realworld-studio-design';

import type { QuestMissionTransitionType } from '../types';

interface QuestMissionTransitionEdgeData {
  label?: string;
  edgeType?: QuestMissionTransitionType;
}

const EDGE_COLORS: Record<QuestMissionTransitionType, string> = {
  goto: '#06b6d4'
};

function QuestMissionTransitionEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style
}: EdgeProps<QuestMissionTransitionEdgeData>) {
  const edgeType = data?.edgeType ?? 'goto';
  const edgeColor = EDGE_COLORS[edgeType];

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition
  });

  return (
    <>
      <defs>
        <marker
          id={`qmt-arrow-${id}`}
          markerWidth="10"
          markerHeight="7"
          refX="9"
          refY="3.5"
          orient="auto"
        >
          <path d="M0,0 L10,3.5 L0,7 Z" fill={edgeColor} />
        </marker>
      </defs>
      <path
        id={id}
        d={edgePath}
        markerEnd={`url(#qmt-arrow-${id})`}
        style={{
          ...style,
          stroke: edgeColor,
          strokeWidth: 2,
          strokeDasharray: '6 4',
          fill: 'none'
        }}
      />
      <EdgeLabelRenderer>
        <div
          css={LabelStyle}
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            color: edgeColor,
            borderColor: edgeColor
          }}
        >
          {data?.label ?? ''}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export default memo(QuestMissionTransitionEdge);

const LabelStyle = css`
  position: absolute;
  pointer-events: none;
  font-size: 10px;
  font-weight: ${typography.weight.bold};
  letter-spacing: 0.04em;
  background-color: #fff;
  padding: 1px 5px;
  border-radius: 3px;
  border: 1px solid;
`;
